<template>
  <component
    :is="componentType"
    :get-data-url="getDataUrl"
    :save-config-url="saveConfigUrl"
    :get-data-with-reset-config-url="getDataWithResetConfigUrl"
    :vue-no-data-template="vueNoDataTemplate"
    :auto-complete-url="autoCompleteUrl"
  />
</template>
<script>
import TableData from './widgets/table.vue';
import TotalStats from './widgets/total-stats.vue';

export default {
  components: {
    'table-component': TableData,
    'total-stats-component': TotalStats,
  },
  props: {
    componentType: {
      type: String,
      required: true,
      default: '',
    },
    getDataUrl: {
      type: String,
      required: true,
      default: '',
    },
    saveConfigUrl: {
      type: String,
      required: true,
      default: '',
    },
    getDataWithResetConfigUrl: {
      type: String,
      required: true,
      default: '',
    },
    vueNoDataTemplate: {
      type: String,
      required: true,
      default: '',
    },
    autoCompleteUrl: {
      type: String,
      required: true,
      default: '',
    },
  },
};
</script>
